import { render, staticRenderFns } from "./bewertung.vue?vue&type=template&id=0ba3487d&"
import script from "./bewertung.vue?vue&type=script&lang=js&"
export * from "./bewertung.vue?vue&type=script&lang=js&"
import style0 from "./bewertung.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports